export const MAX_LOAD_TIME_DIFF = 5 * 60 * 60 * 1000;
export const MIN_LOAD_TIME = -1;
export const MAX_LOAD_TIME_DIFF_HIERARCHIES = 60 * 1000;
